// extracted by mini-css-extract-plugin
export default {"container":"el-z","blurb":"fl-z","links":"gl-z"};